import axios from 'axios';

import env from '~/configs/env';
import { useTokenStore } from '~/stores/token/useTokenStore';
import { setupAuthInterceptor } from './setupAuthInterceptor';

const apiSso = axios.create({
  baseURL: `${env.BASE_URL}identity`,
});

apiSso.interceptors.request.use(config => {
  if (config.headers && !config.url?.includes('/connect/token')) {
    config.headers.Authorization = `Bearer ${useTokenStore.getAccess()}`;
  }
  return config;
});

setupAuthInterceptor(apiSso, {
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

const apiNotifications = axios.create({
  baseURL: `${env.NOTIFICATIONS_BASE_URL}`,
});

apiNotifications.interceptors.request.use(config => {
  if (config.headers) {
    config.headers.Authorization = `Bearer ${useTokenStore.getAccess()}`;
  }
  return config;
});

setupAuthInterceptor(apiNotifications, {
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

const apiProducer = axios.create({
  baseURL: env.PRODUCER_BASE_URL,
});

apiProducer.interceptors.request.use(config => {
  if (config.headers) {
    config.headers.Authorization = `Bearer ${useTokenStore.getAccess()}`;
  }
  return config;
});

setupAuthInterceptor(apiProducer, {
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

export { apiNotifications, apiProducer, apiSso };
